import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var personalShopSessionIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.102 1.554c-1.419 0-2.569 1.488-3.349 4.583h6.698c-.78-3.095-1.93-4.583-3.349-4.583m0-1.5c2.357 0 3.946 2.075 4.89 6.083h3.152a.75.75 0 0 1 .75.75v3.149h-.5a1 1 0 0 1-1-1V7.638l-2.095-.001c.091.512.174 1.048.248 1.61l.05.38-.509.064a1 1 0 0 1-1.112-.848l-.126-.79-.074-.416H6.428l-.074.417-.109.678-.015.103a.998.998 0 0 1-1.113.856l-.509-.063c.086-.701.185-1.365.296-1.991H3v11.39a2.5 2.5 0 0 0 2.335 2.495l.165.005 2.853-.001a1 1 0 0 1 .994.882l.006.118v.5H5.5a4 4 0 0 1-4-4V6.888c0-.415.335-.75.75-.75l2.962-.001C6.156 2.129 7.745.054 10.102.054"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.852 12.5a5 5 0 0 0-5 5 5 5 0 0 0 5 5 5 5 0 0 0 5-5 5 5 0 0 0-5-5m0-1.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.602 15.453v1.782h2.214v.5a1 1 0 0 1-1 1h-1.714a1 1 0 0 1-1-1v-3.282h.5a1 1 0 0 1 1 1"
})));

export { personalShopSessionIcon as default };
//# sourceMappingURL=personalShopSessionIcon.js.map
